<div [formGroup]="form">
    <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="cancel()">
            <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">Pause Monitor</h4>
    </div>
    <div class="modal-body">
        <div class="form-group row">
            <div class="col-sm-6">
                <label>End time for pause</label>
                <ep-datetime-picker  #datepickerTo type="datetime" (selectedDatetimeChange)="updateSelectedToDate($event)" [minDate]="minDate"></ep-datetime-picker>
                <div [class.invisible]="!form.get('toDate').hasError('required')" class="error">
                    <span>Required</span>
                </div>
            </div>
        </div>
        <br />
        <div class="form-group">
            <label for="description">Reason</label>
            <input [class.invalid-state-border]="form.get('description').invalid" type="text" class="form-control" formControlName="description" />
            <div [class.invisible]="!form.get('description').hasError('required') || form.get('description').untouched" class="error">
                <span>Required</span>
            </div>
        </div>
        <br />
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="ok()" [disabled]="form.invalid">Ok</button>
        <button type="button" class="btn btn-link" (click)="cancel()">Cancel</button>
    </div>
</div>
